import { postAPI } from '../../../utils/utils';
import CrearAmbIa from '../ai/CrearAmbIa';

function CrearTab({ setSvg, setPlantillaDefaultName }) {
    const upload_plantilla_aleta = (nom, data) => {
        const formatName = name => name
            .replace(/[^a-zA-Z0-9_()-]/g, '')
            .toLowerCase();

        const formattedNom = formatName(nom)

        const formattedData = Object.fromEntries(
            Object.entries(data)
                .map(([key, value]) => {
                    return [
                        key,
                        {
                            ...value,
                            perfil: undefined,
                            etiqueta: undefined,
                            pestanya: undefined,
                        }
                    ]
                }
        ))

        postAPI(
            '/upload_plantilla',
            {
                nom: formattedNom,
                data: formattedData,
            },
            () => {
                window.location.href = `/editor/${formattedNom}`;
            }
        )
    };

    return (
        <>
            {/* Intro paragraph */}
            <p style={{
                fontSize: 16,
                color: '#6b7280',
                marginBottom: 32,
                maxWidth: 700,
                lineHeight: 1.6,
            }}>
                Crea una plantilla a partir d’un dibuix amb IA, puja un fitxer SVG amb les posicions o importa una plantilla existent en format .aleta.
            </p>

            {/* Instructions Section */}
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: 16,
                padding: 32,
                marginBottom: 48,
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                border: '1px solid #f3f4f6',
            }}>
                <h2 style={{
                    fontSize: 24,
                    fontWeight: 600,
                    color: '#111827',
                    marginBottom: 24,
                }}>
                    Crear a partir d’un SVG
                </h2>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: 24,
                }}>
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            backgroundColor: '#eff6ff',
                            color: '#2563eb',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 600,
                            flexShrink: 0,
                        }}>
                            1
                        </div>
                        <div>
                            <h3 style={{ margin: '0 0 8px 0', color: '#374151' }}>
                                Carrega un fitxer SVG
                            </h3>
                            <p style={{ margin: 0, color: '#6b7280', fontSize: 15 }}>
                                Puja el teu fitxer SVG amb les posicions del castell
                            </p>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            backgroundColor: '#f0fdf4',
                            color: '#16a34a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 600,
                            flexShrink: 0,
                        }}>
                            2
                        </div>
                        <div>
                            <h3 style={{ margin: '0 0 8px 0', color: '#374151' }}>
                                Comprova la visualització
                            </h3>
                            <p style={{ margin: 0, color: '#6b7280', fontSize: 15 }}>
                                Assegura't que es vegi correctament
                            </p>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            backgroundColor: '#fef3c7',
                            color: '#d97706',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 600,
                            flexShrink: 0,
                        }}>
                            3
                        </div>
                        <div>
                            <h3 style={{ margin: '0 0 8px 0', color: '#374151' }}>
                                Guarda la plantilla
                            </h3>
                            <p style={{ margin: 0, color: '#6b7280', fontSize: 15 }}>
                                Fes clic al botó de guardar
                            </p>
                        </div>
                    </div>
                </div>

                <div style={{
                    backgroundColor: '#fef3c7',
                    borderRadius: 12,
                    padding: 16,
                    marginTop: 24,
                    display: 'flex',
                    gap: 12,
                    alignItems: 'flex-start',
                }}>
                    <span style={{ fontSize: 20 }}>⚠️</span>
                    <div>
                        <strong style={{ color: '#92400e' }}>Important:</strong>
                        <span style={{ color: '#92400e' }}> Recorda desagrupar tots els elements del fitxer SVG abans de penjar-lo.</span>
                    </div>
                </div>
            </div>

            {/* Upload Section */}
            <div className="crear-upload-options" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))',
                gap: 24,
                marginBottom: 48,
            }}>
                <div style={{
                    backgroundColor: '#ffffff',
                    borderRadius: 16,
                    padding: 32,
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                    border: '2px dashed #e5e7eb',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#2563eb';
                    e.currentTarget.style.backgroundColor = '#f0f9ff';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.backgroundColor = '#ffffff';
                }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>📄</div>
                    <h3 style={{
                        fontSize: 20,
                        fontWeight: 600,
                        color: '#111827',
                        marginBottom: 8,
                    }}>
                        Puja un fitxer SVG
                    </h3>
                    <p style={{
                        color: '#6b7280',
                        marginBottom: 16,
                        fontSize: 14,
                    }}>
                        Arrossega o selecciona el teu fitxer
                    </p>
                    <label style={{
                        display: 'inline-block',
                        backgroundColor: '#2563eb',
                        color: 'white',
                        padding: '12px 24px',
                        borderRadius: 8,
                        cursor: 'pointer',
                        fontWeight: 500,
                        transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#1d4ed8';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#2563eb';
                    }}>
                        <input
                            type="file"
                            id="file-svg"
                            accept=".svg"
                            style={{ display: 'none' }}
                            onChange={e => {
                                const file = e.target.files[0];
                                const reader = new FileReader();
                                reader.onload = e => {
                                    setPlantillaDefaultName(file.name.split('.')[0]);
                                    setSvg(e.target.result);
                                    window.history.pushState({}, '', '/editor/new');
                                }
                                reader.readAsText(file);
                            }}
                        />
                        Selecciona fitxer SVG
                    </label>
                </div>

                <div style={{
                    backgroundColor: '#ffffff',
                    borderRadius: 16,
                    padding: 32,
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                    border: '2px dashed #e5e7eb',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#7c3aed';
                    e.currentTarget.style.backgroundColor = '#faf5ff';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.backgroundColor = '#ffffff';
                }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>🎯</div>
                    <h3 style={{
                        fontSize: 20,
                        fontWeight: 600,
                        color: '#111827',
                        marginBottom: 8,
                    }}>
                        Puja un fitxer Aleta
                    </h3>
                    <p style={{
                        color: '#6b7280',
                        marginBottom: 16,
                        fontSize: 14,
                    }}>
                        Importa una plantilla existent
                    </p>
                    <label style={{
                        display: 'inline-block',
                        backgroundColor: '#7c3aed',
                        color: 'white',
                        padding: '12px 24px',
                        borderRadius: 8,
                        cursor: 'pointer',
                        fontWeight: 500,
                        transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#6d28d9';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#7c3aed';
                    }}>
                        <input
                            type="file"
                            id="file-aleta"
                            accept=".aleta"
                            style={{ display: 'none' }}
                            onChange={e => {
                                const file = e.target.files[0];
                                const reader = new FileReader();
                                reader.onload = e => {
                                    const nom = file.name.replace('.aleta', '').replaceAll('.', '-');
                                    const data = JSON.parse(e.target.result);
                                    upload_plantilla_aleta(nom, data);
                                }
                                reader.readAsText(file);
                            }}
                        />
                        Selecciona fitxer .aleta
                    </label>
                </div>

                <CrearAmbIa onOpen={(generatedSvg, name) => {
                    setPlantillaDefaultName(name);
                    setSvg(generatedSvg);
                    window.history.pushState({}, '', '/editor/new');
                }} />
            </div>

            {/* Info Section */}
            <div style={{
                backgroundColor: '#f0f9ff',
                borderRadius: 16,
                padding: 24,
                marginBottom: 48,
                border: '1px solid #bfdbfe',
            }}>
                <h3 style={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: '#1e40af',
                    marginBottom: 16,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                }}>
                    <span>💡</span> Consells per crear fitxers SVG
                </h3>
                <ul style={{
                    margin: 0,
                    paddingLeft: 24,
                    color: '#3730a3',
                    lineHeight: 1.8,
                }}>
                    <li>Les posicions han de ser rectangles (altres formes no es llegiran)</li>
                    <li>El bloc base hauria de fer 100×50 píxels - <a href="/blocbase.svg" download="blocbase.svg" style={{ color: '#2563eb', textDecoration: 'underline' }}>descarrega'l aquí</a></li>
                    <li>Utilitza editors com <a href="https://editor.method.ac/" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb', textDecoration: 'underline' }}>Method Draw</a> per pinyes senzilles</li>
                    <li>Els companys arquitectes tenen les millors eines - pregunta'ls-hi!</li>
                </ul>
            </div>
        </>
    );
}

export default CrearTab;
